import { c as _c } from "react/compiler-runtime";
import { useQueryState } from 'nuqs';
import { parseAsSearchString } from '@/hooks/searchParamParsers';
import Fuse, { IFuseOptions } from 'fuse.js';
import { useEffect, useMemo, useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { FormApi, createForm } from 'final-form';
export type SearchFormValues = {
  fulltext: string;
};
export type SearchResult = {
  title: string;
  description: string;
  keywords: string;
  type: 'question' | 'category';
  icon?: string;
  slug: string;
};
const fuseOptions: IFuseOptions<SearchResult> = {
  shouldSort: true,
  findAllMatches: true,
  threshold: 0.4,
  location: 0,
  distance: 100,
  minMatchCharLength: 1,
  keys: [{
    name: 'title',
    weight: 3
  }, {
    name: 'keywords',
    weight: 2
  }, {
    name: 'description',
    weight: 1.5
  }]
};
export function useFaqSearch(searchableItems) {
  const $ = _c(26);
  let t0;
  if ($[0] !== searchableItems) {
    t0 = new Fuse(searchableItems, fuseOptions);
    $[0] = searchableItems;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const searchResource = t0;
  const [fulltext, setFulltext] = useQueryState("q", parseAsSearchString);
  const t1 = fulltext ?? "";
  let t2;
  if ($[2] !== t1) {
    t2 = {
      fulltext: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const formValues = t2;
  let t3;
  if ($[4] !== setFulltext) {
    t3 = values => {
      setFulltext(values.fulltext || null);
    };
    $[4] = setFulltext;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const sync = t3;
  let t4;
  if ($[6] !== formValues || $[7] !== sync) {
    t4 = () => createForm({
      initialValues: formValues,
      onSubmit: values_0 => {
        sync(values_0);
      }
    });
    $[6] = formValues;
    $[7] = sync;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const [searchForm] = useState(t4);
  let t5;
  let t6;
  if ($[9] !== formValues || $[10] !== searchForm) {
    t5 = () => {
      if (typeof window !== "undefined") {
        searchForm.reset(formValues);
      }
    };
    t6 = [formValues, searchForm];
    $[9] = formValues;
    $[10] = searchForm;
    $[11] = t5;
    $[12] = t6;
  } else {
    t5 = $[11];
    t6 = $[12];
  }
  useEffect(t5, t6);
  let t7;
  if ($[13] !== formValues) {
    t7 = ["faqSearch", formValues];
    $[13] = formValues;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== formValues || $[16] !== searchResource) {
    t8 = async () => {
      if (formValues.fulltext) {
        const results = searchResource.search(formValues.fulltext, {
          limit: 5
        });
        const categories = results.filter(_temp).map(_temp2);
        const questions = results.filter(_temp3).map(_temp4);
        return {
          categories,
          questions
        };
      } else {
        return null;
      }
    };
    $[15] = formValues;
    $[16] = searchResource;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = {
      queryKey: t7,
      queryFn: t8
    };
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const query = useQuery(t9);
  let t10;
  if ($[21] !== formValues || $[22] !== query || $[23] !== searchForm || $[24] !== sync) {
    t10 = {
      query,
      setFilter: sync,
      formValues,
      searchForm
    };
    $[21] = formValues;
    $[22] = query;
    $[23] = searchForm;
    $[24] = sync;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
}
function _temp4(result_2) {
  return result_2.item;
}
function _temp3(result_1) {
  return result_1.item.type === "question";
}
function _temp2(result_0) {
  return result_0.item;
}
function _temp(result) {
  return result.item.type === "category";
}